import React, { createContext, useState, useContext } from "react";

// Create context for user data
const UserContext = createContext();

// Provide the user context to your app
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Set up user state

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to access the user data
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
